import makeStyles from '@mui/styles/makeStyles';

const sidebarStyles = makeStyles((theme) => {
    return {
        sidebarWrapperLg: {
            minHeight: '100%',
            overflowY: 'auto',
            display: 'flex',
            flexDirection: 'column',
            paddingTop: '0'
        },
        appSidebarMenu: {
            backgroundColor: theme.palette.primary.lighten95,
            height: '100%'
        },
        sidebarWrapper: (props) => {
            const { sidebarToggle } = props;
            return {
                height: `calc(var(--app-vh, 100vh) - ${theme.themeVars.headerHeight})`,
                overflow: 'hidden',
                zIndex: '60',
                position: 'fixed',
                top: theme.themeVars.headerHeight,
                transition: 'all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1)',
                width: sidebarToggle ? 0 : theme.themeVars.sidebarWidth,
                '&:hover': {
                    transition: 'width 0.5s linear 0.3s'
                    //width: 'max-content',
                }
            };
        },
        sidebarContent: {
            height: `calc(var(--app-vh, 100vh) - ${theme.themeVars.headerHeight})`,
            overflow: 'hidden'
        },
        menuTreeContainer: {
            height: '62%',
            overflowY: 'auto'
        },
        sidebarFavorites: {
            height: `calc(38% - ${theme.themeVars.sidebarFooterHeight})`,
            overflowY: 'auto',
            borderTop: `1px solid ${theme.palette.secondary.light}`
        },
        sidebarFooter: {
            height: theme.themeVars.sidebarFooterHeight
        },
        sidebarMenus: {
            height: `calc(100% - ${theme.themeVars.sidebarFooterHeight})`,
            position: 'relative',
            flexFlow: 'column'
        },
        activeItem: {
            color: theme.palette.accent.main,
            backgroundColor: theme.palette.mode === 'dark'
                ? 'rgba(255, 176, 30, 0.12)'
                : 'rgba(255, 176, 30, 0.10)',
            borderLeft: `3px solid ${theme.palette.accent.main}`,
            borderRadius: '0 6px 6px 0',
            boxShadow: theme.palette.mode === 'dark'
                ? 'inset 0 0 0 1px rgba(255,176,30,0.18)'
                : 'none',
            '&:hover': {
                backgroundColor: 'rgba(255, 176, 30, 0.15)'
            }
        },
        icon: {
            padding: '4px 40px',
            borderRadius: '10px',
            '& .MuiSvgIcon-root': {
                width: '1.1em'
            }
        },
        tooltip: {
            backgroundColor: theme.palette.primary.main,
            padding: theme.spacing(1),
            opacity: `0.85 !important`,
            fontSize: '12px',
            lineHight: 1
        },
        divider: {
            height: '1px',
            // MUI's Divider draws its own border-bottom; left on, the rule is
            // 2px tall here and 1px in the footer, and they stop lining up.
            border: 'none',
            // The app footer's top border is the separator drawn OVER the
            // header colour; this divider sits over the sidebar instead, so on
            // its own it read as a grey line with the navy starting 1px lower.
            // Painting the same overlay on the same colour makes the two one line.
            background: theme.palette.brandFooter
                ? `linear-gradient(var(--separator, #e5e7eb), var(--separator, #e5e7eb)), ${theme.palette.brandFooter}`
                : 'var(--separator, #e5e7eb)'
        },
        // Exactly the app footer's height, so the divider directly above it
        // lands on the footer's top border and the two read as one rule
        // running the full width of the app. Do not give this padding — the
        // band's height IS the alignment.
        sidebarFooterBand: {
            height: theme.themeVars.footerHeight,
            overflow: 'hidden',
            // The app footer's colours (palette.brandFooter), so the footer runs
            // under the sidebar too as one band across the app.
            backgroundColor: theme.palette.brandFooter ?? 'transparent',
            color: theme.palette.brandFooterText
        }
    };
});

export default sidebarStyles;
